﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const form_controls_1 = require("@its-suite/form-controls");
const app_commons_1 = require("@its-suite/app-commons");
function getExceptionResponseInfo(exceptionResponse) {
    try {
        return JSON.parse(exceptionResponse);
    }
    catch (e) {
        return undefined;
    }
}
exports.getExceptionResponseInfo = getExceptionResponseInfo;
function getExceptionMessage(translate, exceptionResponse) {
    const customExceptions = app_commons_1.Constants.EXCEPTIONS;
    let exceptionType;
    let exceptionData;
    const exceptionResponseInfo = getExceptionResponseInfo(exceptionResponse);
    if (exceptionResponseInfo) {
        exceptionType = exceptionResponseInfo.exceptionType;
        exceptionData = exceptionResponseInfo.additionalData;
    }
    else {
        exceptionType = '';
        exceptionData = '';
    }
    switch (exceptionType) {
        case customExceptions.alreadyExists.exceptionName:
            return translate(customExceptions.alreadyExists.exceptionResourceKey);
        case customExceptions.hasDependencies.exceptionName:
            return translate(customExceptions.hasDependencies.exceptionResourceKey);
        case customExceptions.invalidData.exceptionName:
            return translate(customExceptions.invalidData.exceptionResourceKey);
        case customExceptions.doesNotExist.exceptionName:
            return translate(customExceptions.doesNotExist.exceptionResourceKey);
        case customExceptions.database.exceptionName:
            return translate(customExceptions.database.exceptionResourceKey);
        case customExceptions.forbiddenAccess.exceptionName:
            window.location.assign(app_commons_1.ApplicationRoutes.INVALID_PERMISSIONS);
            return translate(customExceptions.forbiddenAccess.exceptionResourceKey);
        case customExceptions.unauthorized.exceptionName:
            window.location.assign(app_commons_1.ApplicationRoutes.INVALID_SESSION);
            return translate(customExceptions.unauthorized.exceptionResourceKey);
        case customExceptions.reusedPasswordException.exceptionName:
            return translate(customExceptions.reusedPasswordException.exceptionResourceKey);
        case customExceptions.passwordTooSimilarException.exceptionName:
            return translate(customExceptions.passwordTooSimilarException.exceptionResourceKey);
        case customExceptions.wrongPasswordException.exceptionName:
            return translate(customExceptions.wrongPasswordException.exceptionResourceKey);
        case customExceptions.lockedAccountException.exceptionName:
            return form_controls_1.StringHelpers.format(translate(customExceptions.lockedAccountException.exceptionResourceKey), exceptionData);
        case customExceptions.detourWithoutAffectedRoutesException.exceptionName:
            return translate(customExceptions.detourWithoutAffectedRoutesException.exceptionResourceKey, customExceptions.detourWithoutAffectedRoutesException.exceptionResourceFile);
        default:
            return translate(customExceptions.default.exceptionResourceKey);
    }
}
exports.getExceptionMessage = getExceptionMessage;
//# sourceMappingURL=ExceptionManager.js.map